module.exports = __webpack_public_path__ + "img/share_link.e7f4a492.svg";